// extracted by mini-css-extract-plugin
export var modal_download = "ModalDownload-module--modal_download--1xf6-";
export var modal_content = "ModalDownload-module--modal_content--LULCq";
export var information = "ModalDownload-module--information--1F8F1";
export var information_content = "ModalDownload-module--information_content--2oyuv";
export var description = "ModalDownload-module--description--2BCZI";